module.exports = __webpack_public_path__ + "static/img/beian.d0289dc0.png";